<template>
  <div class="full">
    <QuestionBuilderEngine @saving="(v) => { saving = v }" :saving="saving" class="full" :dbObject="fullObject" v-if="fullObject && question" :question="question" @save="onSave"></QuestionBuilderEngine>
  </div>
</template>

<script>
import QuestionBuilderEngine from './QuestionBuilderEngine.vue'
import * as QS from '../yoqb-compos/question'
import * as Question from '@/api/question.js'
import * as Folder from '@/api/folders.js'
// import * as Auth from '@/api/login.js'

export default {
  components: {
    QuestionBuilderEngine
  },
  data () {
    return {
      saving: 'saved',
      fullObject: false,
      question: false
    }
  },
  computed: {
    questionID () {
      return this.$route.params.questionID
    }
  },
  mounted () {
    this.onLoad()
    this.$forceUpdate()
  },
  methods: {
    async onLoad () {
      let resp = await Question.getQuestion({ _id: this.questionID })
      this.fullObject = resp.data
      this.question = resp.data.document

      this.$forceUpdate()
      // this.question = QS.makeSampleQuestion()
    },
    async onSave (q) {
      clearTimeout(this.autosave)
      this.saving = 'saving'
      this.fullObject.document = q
      await Question.updateQuestion(this.fullObject)
      this.autosave = setTimeout(() => {
        this.saving = 'saved'
      }, 1000)
      this.$forceUpdate()

      console.log(q)
      // window.qq = q
      // console.log('copy(window.qq)')
    }
  }
}
</script>

<style scoped>

.full{
  width: 100%;
  height: 100%;
}
</style>
